<template>
  <Header />
  <Herosection />
  <MassReading />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Herosection from "@/components/HeroSectionPage.vue";
import Footer from "@/components/Footer.vue";
import MassReading from "@/components/views/MassReading.vue";

export default {
  components: {
    Header,
    Herosection,
    Footer,
    MassReading,
  },
};
</script>
